import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AgendaClienteDetalhe, AgendaItemDetalhe } from 'src/app/admihair/api/dto/agenda-cliente-detalhe';
import { Cliente } from 'src/app/admihair/api/dto/cliente';
import { AgendaEmpresaItemServicoService } from 'src/app/admihair/service/agenda-empresa-item-servico.service';
import { AgendaEmpresaService } from 'src/app/admihair/service/agenda-empresa.service';

import { trigger, transition, style, animate } from '@angular/animations';
import { Profissional } from 'src/app/admihair/api/dto/profissional';
import { ConfiguracaoAgendaProfissionalService } from 'src/app/admihair/service/configuracao-agenda-profissional.service';
import { AgendaEmpresaLoteItem, AgendaEmpresaLoteRequest } from 'src/app/admihair/api/dto/agenda-empresa-lote-request';
import { UtilStorageService } from 'src/app/admihair/service/util-storage.service';
import { DateUtil } from 'src/app/admihair/util/date-util';
import { AdmihairBaseComponent } from 'src/app/admihair/components/admihair-base.component';
import { ErroService } from 'src/app/admihair/service/erro.service';
import { RelatorioClienteService } from 'src/app/admihair/service/relatorio-cliente.service';

interface ItemReagendamento {
  itemId: number;
  descricao: string;
  duracao: string;
  profissionalId?: number;
}

@Component({
  selector: 'app-cliente-agenda-detalhe',
  templateUrl: './cliente-agenda-detalhe.component.html',
  styleUrls: ['./cliente-agenda-detalhe.component.scss']
})
export class ClienteAgendaDetalheComponent extends AdmihairBaseComponent {

  etapaAtual: number = 0;
  loading: boolean = false;
  profissionalSelecionado?: Profissional;
  hoje = new Date();
  novaDataAgendamento?: Date;
  novaHoraAgendamento?: Date;
  salvando = false;
  exibirSelecaoProfissional = false;

  profissionais: Profissional[] = [];

  @Input() visible: boolean = false;
  @Output() visibleChange = new EventEmitter<boolean>();

  clienteSelecionado?: Cliente;
  exibirSelecaoCliente = false;
  dataInicio: Date = this.criarDataInicioPadrao();
  dataFim: Date = this.criarDataFimPadrao();
  listaAgendamentos: AgendaClienteDetalhe[] = [];

  @Output() agendamentoReativado = new EventEmitter<void>();
  @Output() agendamentoReagendado = new EventEmitter<string>();

  selectedItems: AgendaItemDetalhe[] = [];

  listaItensReagendamento: ItemReagendamento[] = [];



  constructor(private agendaItemService: AgendaEmpresaItemServicoService,
    private confAgendaProfissionalService: ConfiguracaoAgendaProfissionalService,
    private agendaEmpresaService: AgendaEmpresaService,
    private relatorioClienteService: RelatorioClienteService,
    erroService: ErroService,
    storageService: UtilStorageService,
  ) {
    super(erroService, storageService)
  }

  selecionarCliente(cliente: Cliente) {
    const alterouCliente = this.clienteSelecionado?.id !== cliente.id;
    this.clienteSelecionado = cliente;

    if (alterouCliente) {
      this.carregarItens();
    }

    this.exibirSelecaoCliente = false;
  }


  selecionarDia() {
    if (!this.novaDataAgendamento) {
      return;
    }
    const diaSemanaId = this.novaDataAgendamento.getDay() + 1;


    this.confAgendaProfissionalService.listarProfissionaisConfiguradosPorDia(diaSemanaId)
      .subscribe({
        next: (data: Profissional[]) => {
          this.profissionais = data;
        },
        error: (err: any) => {
          this.exibirMensagemErroDialog(err);
        }
      })

  }

  salvar() {

    const lote: AgendaEmpresaLoteRequest = {
      clienteId: this.clienteSelecionado?.id!,
      empresaId: this.getEmpresa().id!,
      dataAgendamento: this.novaDataAgendamento!,
      horaInicio: this.novaHoraAgendamento?.toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit', hour12: false })!,
      items: this.listaItensReagendamento.map(item => {
        return {
          itemId: item.itemId,
          profissionalId: item.profissionalId
        } as AgendaEmpresaLoteItem
      })
    }
    this.agendaEmpresaService.salvarAgendamentoLote(lote).subscribe({
      next: () => {
        this.etapaAtual = 0;
        this.carregarItens();
        this.exibirMensagemSucessoDialog();
        this.agendamentoReagendado.emit(DateUtil.formatarDataIsoLocal(this.novaDataAgendamento));
      },
      error: (err: any) => {
        this.exibirMensagemErroDialog(err);
      }
    })
  }

  processarItensSelecionados() {
    this.listaItensReagendamento = this.selectedItems.map(item => {
      return {
        itemId: item.itemServicoId,
        descricao: item.descricao,
        duracao: item.duracao
      } as ItemReagendamento
    })
  }

  avancarEtapa(): void {
    this.processarItensSelecionados();
    this.etapaAtual = 1;
  }

  voltarEtapa(): void {
    this.etapaAtual = 0;
    this.profissionais = [];
    this.novaDataAgendamento = undefined;
  }

  carregarItens() {
    this.agendaEmpresaService.listarAgendamentosDoCliente(
      this.clienteSelecionado?.id!,
      this.dataInicio,
      this.dataFim
    ).subscribe({
      next: (data: AgendaClienteDetalhe[]) => {
        this.listaAgendamentos = data;
      },
      error: (err: any) => {
        this.exibirMensagemErroDialog(err);
      }
    })
  }

  abrirSelecaoCliente() {
    this.exibirSelecaoCliente = true;
  }

  reagendar(agendaEmpresaId: any) {

    this.agendaEmpresaService.reativar(agendaEmpresaId).subscribe({
      next: () => {
        this.agendamentoReativado.emit();
        this.exibirMensagemSucessoDialog();
        this.carregarItens();
      },
      error: (err: any) => {
        this.exibirMensagemErroDialog(err);

      }
    })

  }

  carregarRelatorioCliente() {
    this.relatorioClienteService.gerarRelatorioPdfAgendamentos(this.clienteSelecionado?.id!, this.dataInicio, this.dataFim).subscribe({
      next: (response: Blob) => {
        const url = URL.createObjectURL(response);
        window.open(url, 'blank');
      },
      error: (err) => {
        console.log(err);
      }
    });
  }

  fechar() {
    this.exibirSelecaoCliente = false;
    this.clienteSelecionado = undefined;
    this.visibleChange.emit(false);
  }

  protected resetarEstado() {
    this.exibirSelecaoCliente = false;
    this.dataInicio = this.criarDataInicioPadrao();
    this.dataFim = this.criarDataFimPadrao();
  }

  private criarDataInicioPadrao(): Date {
    const hoje = new Date();
    hoje.setHours(0, 0, 0, 0);
    return hoje;
  }

  private criarDataFimPadrao(): Date {
    const dataFim = this.criarDataInicioPadrao();
    dataFim.setDate(dataFim.getDate() + 7);
    return dataFim;
  }

}
